import React, { ReactNode } from 'react'
import styles from './CommunityHero.module.scss'
import apartmentHeroImage from '../../images/apartment-projects-hero.jpg'
import hoaHeroImage from '../../images/hoa-projects-hero.jpg'
import joinHeroImage from '../../images/join-our-team-hero.jpg'
import heroShape from '../../images/community-page-hero-shape.svg'
import wildCircle from '../../images/wild-circle-2.svg'
import { CommunityType } from '../../lib/types'
import { Image } from '../Image/Image'

const COMMUNITY_HERO_DATA: Record<CommunityType, {
  imageHero: string
  headline: string
  text: string
}> = {
  Apartment: {
    imageHero: apartmentHeroImage,
    headline: 'Power your<br>Apartments<br>on Fiber',
    text: '',
  },
  HOA: {
    imageHero: hoaHeroImage,
    headline: 'Power your<br>HOA with<br>Cityside Fiber',
    text: '',
  },
  Join: {
    imageHero: joinHeroImage,
    headline: 'We’re just<br>getting started',
    text: 'Come join our rapidly growing team in Southern California!',
  },
}

export const CommunityHero = (props: {
  type: CommunityType
  children?: ReactNode
}): React.JSX.Element => {
  const { imageHero, headline, text } = COMMUNITY_HERO_DATA[props.type]

  return (
    <section
      className={`${styles.hero} ${
        styles['hero__' + props.type.toLowerCase()]
      }`}
    >
      <div className={`${styles.hero_color_square}`}></div>

      <div className={`${styles.hero_shape}`}>
        <img src={heroShape} alt="" />
      </div>

      <div className={`grid-12 ${styles.container}`}>
        <div className={styles.wild_circle}>
          <img src={wildCircle} alt="" />
        </div>
        <div className={styles.content}>
          <div className={styles.headline}>
            {headline && (
              <h1 dangerouslySetInnerHTML={{ __html: headline }}></h1>
            )}

            {text && <p className={styles.text}>{text}</p>}
          </div>
          <div className={styles.image}>
            <Image src={imageHero} alt='residential buildings' loading='eager' />
          </div>
        </div>
      </div>
    </section>
  )
}
